import axios from "axios";

const PREFIJO = "/api/Vhm/"

export default {
    buscarPlaca(formulario, nombreMarca){
        const dto = {
            ndt1: formulario.agencia.id,
            dt1: formulario.placa,
            dt2 : nombreMarca
        }
        return axios.post(`${PREFIJO}VmVlVh`,dto);
    }
}